import React, { useState, useContext } from 'react';
import { Button, DialogActions, Grid, TextField, CircularProgress, IconButton } from '@mui/material';
import styles from './styles.module.css';
import CloseIcon from '@mui/icons-material/Close';
import { AlertMessagesContext } from 'react-alert-messages';
import PriceCategoryService from 'services/PriceCategoryService';
import { useTranslation } from 'react-i18next';

export default function PriceCategoryFormDialog({ handleClose, handleSuccess }) {
  const { t: tCommon } = useTranslation('common');
  const { t: tPopup } = useTranslation('popup');
  const [data, setData] = useState({});
  const [isLoading, setLoading] = useState(false);

  const { postAlertMessage } = useContext(AlertMessagesContext);

  const handleCreatePriceCategory = async () => {
    setLoading(true);
    try {
      const newPriceCategory = await PriceCategoryService.createPriceCategory(data);
      postAlertMessage({ text: tPopup('Price category created successfully'), type: 'success' });
      handleSuccess(newPriceCategory);
    } catch (error) {
      postAlertMessage({ text: error.message, type: 'failed' });
    }
    setLoading(false);
  };

  return (
    <>
      <div className={styles.popUp}>
        <div className={styles.contentWrapper}>
          <div className={styles.headSec}>
            <h2 className={styles.editTitle}>{tCommon('Add Price Category')}</h2>
            <IconButton onClick={handleClose} size="small"><CloseIcon /></IconButton>
          </div>
          <div className={styles.inputSec}>
            <Grid container className={styles.inputRow} alignItems="center">
              <Grid item xs={4} sm={4} spacing={2} justify="flex-end" className={styles.inputLabelContainer}>
                <h3 className={styles.inputLabel}>{tCommon('Category Name')}</h3>
              </Grid>
              <Grid item xs={8} sm={8}>
                <TextField
                  label={tCommon('Category Name')}
                  variant="outlined"
                  size="small"
                  fullWidth
                  type="text"
                  value={data.name || ''}
                  onChange={(e) => {
                    setData({ ...data, name: e.target.value });
                  }}
                />
              </Grid>
            </Grid>
            <DialogActions>
              <Button variant="contained" color="secondary" size="small" onClick={handleClose}>
                {tCommon('Close')}
              </Button>
              <Button
                variant="contained"
                color="primary"
                size="small"
                sx={{ bgcolor: '#00a65a' }}
                disabled={!data.name || data.name === '' || isLoading}
                onClick={handleCreatePriceCategory}
              >
                {isLoading ? (
                  <>
                    <CircularProgress size={20} color="inherit" sx={{ mr: 1.25 }} />
                    {tCommon('Creating...')}
                  </>
                ) : (
                  tCommon('Create')
                )}
              </Button>
            </DialogActions>
          </div>
        </div>
      </div>
    </>
  );
}
